export default [{
  path: '/pickGoods/:media/:mediaId',
  name: 'pickGoods',
  component: () => import(/* webpackChunkName: "pickGoods" */'@/pages/pickGoods/index'),
  meta: {
    pageId: 10001,
    spm: 2284,
    commonParams: ['media_type', 'media_id'],
  },
}, {
  path: '/selectedGoods/:media/:mediaId',
  name: 'selectedGoods',
  component: () => import(/* webpackChunkName: "pickGoods" */'@/pages/pickGoods/index'),
  meta: {
    pageId: 10001,
    spm: 2285,
    commonParams: ['media_type', 'media_id'],
  },
}, {
  path: '/pickGoods/more_product',
  name: 'more_product',
  component: () => import(/* webpackChunkName: "moreProduct" */'@/pages/pickGoods/more_product'),
  meta: {
    pageId: 10001,
    spm: 2026,
    store: 'pickGoods',
    commonParams: ['media_type', 'media_id'],
  },
}];
